<template>
  <figure :class="containerClassName" v-lazyImage class="image__wrapper">
    <div class="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <img
      @error="$avatarError"
      :class="[imageClassName]"
      class="image__item"
      :data-url="source"
      alt=""
    />
  </figure>
</template>

<script>
export default {
  name: "customImage",

  props: {
    source: {
      type: String,
      required: true
    },
    imageClassName: {
      type: String
    },
    containerClassName: {
      type: String()
    }
  }
};
</script>
